import { call, put, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import store from 'redux/store';
import {
  GET_ADDCHOOSEYOURSERVICE,
  GET_CHOOSEYOURSERVICE_FAILED,
  GET_CHOOSEYOURSERVICE_REQUESTED,
  GET_CHOOSEYOURSERVICE_SUCCESS,
  GET_ADDCHOOSEYOURSERVICE_FAILED,
  GET_ADDCHOOSEYOURSERVICE_REQUESTED,
  GET_ADDCHOOSEYOURSERVICE_SUCCESS,
  GET_UPDATECHOOSEYOURSERVICE_FAILED,
  GET_UPDATECHOOSEYOURSERVICE_REQUESTED,
  GET_UPDATECHOOSEYOURSERVICE_SUCCESS,
} from 'resources/actionTypes';
import {
  addChooseYourServiceApi,
  chooseYourServiceApi,
  updateChooseYourServiceApi,
} from 'services/ChooseService';
import { getChooseYourService } from 'redux/actions/UserChooseYourService';
import { onLoaderTrigger } from 'redux/actions/CommonAction';

function* fetchChooseYourService(action) {
  try {
    const payload = action.payload || {};
    const userChooseYourService = yield call(chooseYourServiceApi, payload);
    yield put({
      type: GET_CHOOSEYOURSERVICE_SUCCESS,
      userChooseYourService: userChooseYourService,
    });
  } catch (e) {
    yield put({
      type: GET_CHOOSEYOURSERVICE_FAILED,
      message: e.message,
    });
    toast.error(e.message || 'Choose Your Service Failed')
  }
}

export function* ChooseYourServiceSaga() {
  yield takeEvery(GET_CHOOSEYOURSERVICE_REQUESTED, fetchChooseYourService);
}

function* fetchAddChooseYourService(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userAddChooseYourService = yield call(
    addChooseYourServiceApi,
    payload.userAddChooseYourService
  );
  if (userAddChooseYourService.success) {
    yield put({
      type: GET_ADDCHOOSEYOURSERVICE_SUCCESS,
      userAddChooseYourService: userAddChooseYourService,
    });
    toast.success(userAddChooseYourService.message);
    store.dispatch(onLoaderTrigger(false));
    window.location.replace('/welcome');
    store.dispatch(
      getChooseYourService({
        id: payload?.userAddChooseYourService?.get('id'),
        status: '',
        type: payload?.userAddChooseYourService?.get('type'),
      })
    );
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_ADDCHOOSEYOURSERVICE_FAILED,
      message: userAddChooseYourService.message,
    });
      toast.error(userAddChooseYourService.message || 'Service Failed ');
  }
}

export function* addChooseYourServiceSaga() {
  yield takeEvery(
    GET_ADDCHOOSEYOURSERVICE_REQUESTED,
    fetchAddChooseYourService
  );
}

function* fetchUpdateChooseYourService(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userUpdateChooseYourService = yield call(
    updateChooseYourServiceApi,
    payload.userUpdateChooseYourService
  );
  if (userUpdateChooseYourService.success) {
    yield put({
      type: GET_UPDATECHOOSEYOURSERVICE_SUCCESS,
      userUpdateChooseYourService: userUpdateChooseYourService,
    });
    toast.success(userUpdateChooseYourService.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(
      getChooseYourService({ id: payload.userUpdateChooseYourService.id })
    );
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_UPDATECHOOSEYOURSERVICE_FAILED,
      message: userUpdateChooseYourService.message,
    });
      toast.error(userUpdateChooseYourService.message || 'Update  failed');
  }
}

export function* updateChooseYourServiceSaga() {
  yield takeEvery(
    GET_UPDATECHOOSEYOURSERVICE_REQUESTED,
    fetchUpdateChooseYourService
  );
}
